import React from "react";

const Close = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g stroke="currentColor" strokeWidth="2" {...props}>
          <g>
            <path d="M0 12L12 0M0 0l12 12" transform="translate(5 5)" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Close;
